import {
  enableProdMode,
  ErrorHandler,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';

import { httpTranslateLoader } from './app/app.module';
import { environment } from './environments/environment';
import { MAT_ICON_DEFAULT_OPTIONS } from '@angular/material/icon';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { RouteGuardsService } from './app/services/core/route-guards.service';
import { UserDataService } from './app/services/core/user-data.service';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  HttpClient,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { AuthInterceptor } from './app/services/core/auth.interceptor';
import { GlobalErrorHandler } from './app/services/core/global-error-handler.service';
import { ClipboardModule } from 'ngx-clipboard';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app/app-routing.module';
import { provideUiTour } from 'ngx-ui-tour-md-menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatNativeDateModule } from '@angular/material/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AppComponent } from './app/app.component';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(
      ClipboardModule,
      BrowserModule,
      CommonModule,
      FormsModule,
      AppRoutingModule,
      CommonModule,
      MatDialogModule,
      MatAutocompleteModule,
      MatNativeDateModule,
      DragDropModule,
      TranslateModule.forRoot({
        defaultLanguage: 'pt-br',
        loader: {
          provide: TranslateLoader,
          useFactory: httpTranslateLoader,
          deps: [HttpClient],
        },
      }),
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: environment.production,
        // Register the ServiceWorker as soon as the app is stable
        // or after 30 seconds (whichever comes first).
        registrationStrategy: 'registerWhenStable:30000',
      })
    ),
    {
      provide: MAT_ICON_DEFAULT_OPTIONS,
      useValue: { fontSet: 'material-symbols-outlined' },
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'en-GB',
    },
    RouteGuardsService,
    UserDataService,
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideUiTour(),
  ],
}).catch((err) => console.error(err));
